import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './style/index.less';
import store from './store/';
import './permission';
import './core/lazy_lib/components_use';
import { requestUrl, ossUrl } from '@/config/app';
import { get, post, uploadfile } from '@/utils/request';
import TextHighlight from 'vue-text-highlight';

import promise from 'es6-promise';
promise.polyfill();

Vue.config.productionTip = false;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$uploadfile = uploadfile;
Vue.prototype.$url = requestUrl;
Vue.prototype.$ossUrl = ossUrl;
Vue.component('text-highlight', TextHighlight);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
